import 'babel-polyfill';
import 'unfetch/polyfill';
import 'abortcontroller-polyfill';
import 'filepond-polyfill'

require('./../css/app.scss');
require('./../css/legacy-browsers/_ie10and11.scss');
require('./../css/legacy-browsers/_msedge.scss');

if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector;
if (!Element.prototype.closest) Element.prototype.closest = function (selector) {
    var el = this;
    while (el) {
        if (el.matches(selector)) {
            return el;
        }
        el = el.parentElement;
    }
};
